import { render, staticRenderFns } from "./AccountPhonenumber.vue?vue&type=template&id=3316cc09&scoped=true&"
import script from "./AccountPhonenumber.vue?vue&type=script&lang=js&"
export * from "./AccountPhonenumber.vue?vue&type=script&lang=js&"
import style0 from "./AccountPhonenumber.vue?vue&type=style&index=0&id=3316cc09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3316cc09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
